function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a0a0a;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "a1Artboard 1");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M532.75,176.37l-47-48.17a59,59,0,0,0-42-17.7h-52.9a20.43,20.43,0,0,0-20.43,20.36L370,260H27.07A26.07,26.07,0,0,0,1,286.07v29.08c0,36.65,28.52,67.5,65.13,69.15a68.2,68.2,0,0,0,58.3-28A68.26,68.26,0,0,0,246.58,303H386.49a68.28,68.28,0,1,0,134,0H537a11,11,0,0,0,11-11l.39-76.95A55,55,0,0,0,532.75,176.37ZM71.55,344.29a28,28,0,1,1,25.61-25.61A28,28,0,0,1,71.55,344.29Zm110.29,0a28,28,0,1,1,25.61-25.61A28,28,0,0,1,181.84,344.29Zm273.61,0a28,28,0,1,1,25.61-25.61A28,28,0,0,1,455.45,344.29ZM412,192.61V152h31.76a17.17,17.17,0,0,1,12.29,5.18L491,193Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M313.75,0H28.25A28.25,28.25,0,0,0,0,28.25v176.5A28.25,28.25,0,0,0,28.25,233h285.5A28.25,28.25,0,0,0,342,204.75V28.25A28.25,28.25,0,0,0,313.75,0ZM311,202H31V31H311Z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 64.45,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 126.49,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 188.52,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 250.56,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var SvgTruckStorageEmpty = function SvgTruckStorageEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 548.39 384.38",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruckStorageEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/truck-storage-empty.9b864e6e.svg";
export { ForwardRef as ReactComponent };